import React, { useEffect, useState } from 'react'
import { makeAjax, respStatus, url, showMessage } from '../../../../helpers/global_helper';
import closeIcon from "../../../../assets/images/Icons/close_icon.svg";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { formatPricewithdecimal } from "../../../NumberFormat";
import { IoMdClose } from "react-icons/io";

const BetPopup = (props) => {
  const { onClose, gameid, period, act, subgame } = props;
  let periodArray = period.split('#').map(Number);
  const [invoiceTogleDetailData, setInvoiceTogleDetailsData] = useState([]);
  const [gameCode, setGameCode] = useState('');
  const [totalBuyers, setTotalBuyers] = useState(0);
  const device = useSelector(state => state.CommonConfig.device_type);


  // api for Transection History Detail
  const featchInvoiceTogleDetail = () => {

    let reqData = {
      game_id: gameid,
      act: 22,
      period: periodArray,
      subgame: subgame,


    };
    makeAjax(url.TOGEL_API.getInvoiceTogel, reqData).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setInvoiceTogleDetailsData(response.data.result ? response.data.result : response.data);
      setGameCode(response.data.game.game_code)
      // Calculate total buyers
      if (response.data.result) {
        const total = response.data.result.reduce((accumulator, currentValue) => {

          return accumulator + parseFloat(currentValue.win_amount);
        }, 0);


        setTotalBuyers(total);
      }

    });
  };


  useEffect(() => {
    featchInvoiceTogleDetail();
  }, []);
  return (
    <div className="overlay">
      <div className='overlay_innerDiv' onClick={onClose}></div>
      <div className="turnover_info_popup">
        <button className="informasi_popup-close" onClick={onClose}>
          <IoMdClose className="btnclose"/>    
        </button>
        <div className="result_txt">WIN STATUS</div>

        {/* table */}
        {device === "Desktop" ?
          <div className="informasi_tble_result">
            <table>
              <thead>
                <tr>
                  <th>{props.t("period")}</th>
                  <th>{props.t("bet")} </th>
                  {(subgame === 5 || subgame === 6 || subgame === 14) && (
                    <th>{props.t("bet")}2</th>
                  )}
                  {subgame === 6 && <th>{props.t("bet")}3</th>}
                  {(subgame === 3 || subgame === 7) && (
                    <th>{props.t("position")}</th>
                  )}
                  <th>{props.t("amount")}</th>
                  <th>{props.t("discount")} %</th>
                  {[8, 9, 10, 12, 13, 42].includes(subgame) ? (
                    <th>{props.t('kei')} %</th>
                  ) : (
                    <th>{props.t("prize")}</th>
                  )}
                  <th>{props.t("total_amount")}</th>
                  <th>{props.t("desc")}</th>
                </tr>
              </thead>
              <tbody>



                {(invoiceTogleDetailData.length == 0 ?
                  <tr className="table_data_empty_row">
                    <td colSpan="11">{props.t("data_not_found")}</td>
                  </tr>

                  :
                  invoiceTogleDetailData.map((value, index) => (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      <td>{value.period}-{gameCode}</td>
                      <td>{value.bet}</td>
                      {(subgame === 5 || subgame === 6 || subgame === 14) && (
                        <td>{value.bet2}</td>
                      )}
                      {subgame === 6 && <td>{value.bet3}</td>}
                      {(subgame === 3 || subgame === 7) && (
                        <td>{value.posisi}</td>
                      )}
                      <td>{formatPricewithdecimal(value.amount)}</td>
                      <td>{value.disc}</td>
                      <td>{value.prizekei}</td>
                      <td>{formatPricewithdecimal(value.win_amount)}</td>
                      <td>{value.info}</td>


                    </tr>
                  )))}
              </tbody>
            </table>
            <div className='total_price_div'>
              {props.t("total")}: {formatPricewithdecimal(totalBuyers.toFixed(2))}
            </div>
          </div>
          :
          <>
            {invoiceTogleDetailData.length == 0 ?
              <div className='invoice_tbl_container'>
                <p className='no_data'>{props.t("data_not_found")}</p>
              </div>
              :
              <div className='invoice_tbl_container'>
                {invoiceTogleDetailData.map((value, index) => (
                  <div className='invoice_tbl'>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("period")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {value.period}-{gameCode}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("bet")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {value.bet}
                      </div>
                    </div>
                    {(subgame === 5 || subgame === 6 || subgame === 14) && (
                      <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                          <p>{props.t("bet")}2</p>
                        </div>
                        <div className='invoice_clmn2'>
                          {value.bet2}
                        </div>
                      </div>
                    )}
                    {(subgame === 6) && (
                      <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                          <p>{props.t("bet")}3</p>
                        </div>
                        <div className='invoice_clmn2'>
                          {value.bet3}
                        </div>
                      </div>
                    )}
                    {(subgame === 3 || subgame === 7) && (
                      <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                          <p>{props.t("position")}</p>
                        </div>
                        <div className='invoice_clmn2'>
                          {value.posisi}
                        </div>
                      </div>
                    )}
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("amount")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {formatPricewithdecimal(value.amount)}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("discount")} %</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {value.disc}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("prize")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {value.prizekei}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("total_amount")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                      {formatPricewithdecimal(value.win_amount)}
                      </div>
                    </div>
                    {/* <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("x_win")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {formatPricewithdecimal(value.win_amount)}
                      </div>
                    </div> */}
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("desc")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {value.info}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            }
            <div className='total_price_div'>
              {props.t("total")}: {formatPricewithdecimal(totalBuyers)}
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default withTranslation()(BetPopup)